<div class="container-fluid py-5 iff-detail-header-cell-text">
  <div>
    <app-iff-detail-header
      [selectedIFFShipmentSummary$]="selectedIFFShipmentSummary$"
      [isFRTShipment] = "true" (exportClicked)="onExport()"
    ></app-iff-detail-header>
  </div>
  <ag-grid-angular
    class="ag-theme-alpine"
    [gridOptions]="frtIFFShipmentDetailGridOptions"
    [rowData]="frtIFFShipmentDetailResults$ | async"
  >
  </ag-grid-angular>
</div>
